import Swiper, { Navigation, Pagination } from 'swiper';
import { replaceVideoSrcs, videoIsPlaying } from './video.service';
let swiperLoaded = false;
let videoSwiper;
document.addEventListener('DOMContentLoaded', function () {
    /**
     * Swiper
     */
    const videoSwiperEl = document.querySelector('.video-swiper');
    videoSwiper = new Swiper(videoSwiperEl, {
        modules: [Navigation, Pagination],
        direction: 'horizontal',
        slidesPerView: 1,
        spaceBetween: 0,
        autoplay: {
            delay: 5000,
        },
        breakpoints: {
            768: {
                direction: 'vertical',
            },
        },
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        threshold: 4,
        on: {
            slideChangeTransitionEnd: function () {
                if (swiperLoaded) {
                    const currentSlide = videoSwiperEl.querySelector('.swiper-slide-active');
                    const currentVideoEl = currentSlide?.querySelector('video');
                    if (currentVideoEl) {
                        replaceVideoSrcs(currentVideoEl);
                        if (!videoIsPlaying(currentVideoEl)) {
                            currentVideoEl.play();
                        }
                    }
                }
                if (videoSwiper?.previousIndex) {
                    const previousSlide = videoSwiperEl.querySelectorAll('.swiper-slide')[videoSwiper.previousIndex];
                    const previousVideoEl = previousSlide.querySelector('video');
                    if (previousVideoEl) {
                        if (videoIsPlaying(previousVideoEl)) {
                            previousVideoEl.pause();
                        }
                    }
                }
                swiperLoaded = true;
            },
        },
    });
    /**
     * Control buttons
     */
    Array.from(document.getElementsByClassName('btn-watch-video')).forEach(btn => {
        btn.addEventListener('click', () => {
            document.getElementById('video-swiper')?.classList.add('fullscreen-mode', 'swiper-no-swiping');
            const videoEl = videoSwiperEl.querySelector('.swiper-slide-active')?.querySelector('video');
            if (videoEl) {
                videoEl.muted = false;
            }
        });
    });
    document.querySelector('#video .btn-close')?.addEventListener('click', () => {
        document.getElementById('video-swiper')?.classList.remove('fullscreen-mode', 'swiper-no-swiping');
        const videoEl = videoSwiperEl.querySelector('.swiper-slide-active')?.querySelector('video');
        if (videoEl) {
            videoEl.muted = true;
        }
    });
    Array.from(document.getElementsByClassName('btn-mute')).forEach(btn => {
        btn.addEventListener('click', () => {
            const video = btn.parentNode?.querySelector('video');
            if (video) {
                if (video.muted) {
                    video.muted = false;
                    btn.classList.remove('is-muted');
                }
                else {
                    video.muted = true;
                    btn.classList.add('is-muted');
                }
            }
        });
    });
    Array.from(document.getElementsByClassName('btn-replay')).forEach(btn => {
        btn.addEventListener('click', () => {
            if (btn.parentNode) {
                const videoEl = btn.parentNode.querySelector('video');
                if (videoEl) {
                    videoEl.currentTime = 0;
                }
            }
        });
    });
    /**
     * Only play when in view
     */
    const options = {
        rootMargin: '0px',
        threshold: [0, 1],
    };
    let initialInView = true;
    const observer = new IntersectionObserver(event => {
        const currentVideoEl = videoSwiperEl.querySelector('.swiper-slide-active')?.querySelector('video');
        if (!currentVideoEl) {
            return null;
        }
        const isPlaying = videoIsPlaying(currentVideoEl);
        if (event[0].isIntersecting) {
            if (initialInView) {
                initialInView = false;
                replaceVideoSrcs(currentVideoEl);
            }
            if (!isPlaying) {
                currentVideoEl.play();
            }
        }
        else if (!event[0].isIntersecting && isPlaying) {
            const videoEl = videoSwiperEl.querySelector('.swiper-slide-active')?.querySelector('video');
            if (videoEl) {
                videoEl.pause();
            }
        }
    }, options);
    observer.observe(videoSwiperEl);
});
